var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column field-details"},[_c('span',{staticClass:"field-label text-muted"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }